import { queryClient } from '../../ReactQuery';

/**
 * Helper for if you need to force a refetch of the permissions.
 * This is useful if you do a mutation (like a PUT) that would change the permissions
 * on the backend, and you want to get the updated permissions on the frontend.
 *
 * @example
 * const { mutate: onUpdateUser } = useUpdateUser();
 * const updateUser = async (user: User) => {
 *   await onUpdateUser(user);
 *   refetchPermissions();
 * };
 */
const refetchPermissions = () => queryClient.invalidateQueries(['users', 'permissions']);

export default refetchPermissions;
